import { Api } from './Api';
import { makeWithdrawalResponse, PaymentCreation, TransferAccount, WithdrawalPayload, withdrawalReceipt } from '../types/transactions';
import { env } from '../config/config';

export type PaymentList = {
    cursor: string | undefined,
    limit: number,
    sort: string
}

export type PaymentHistoryList = {
    activity: string,
    created_at: string,
    event: Event,
    id: string,
    user_id: string
}


export type PaymentHistoryData = {
    code: 0,
    data: Activities[],
    has_next: boolean,
    next_cursor: string,
    prev_cursor: string,
    success: boolean
}

export type Activities = {
    activity: string,
    created_at: string,
    event: Event,
    id: string,
    user_id: string
}

export type Event = {
    amount: number,
    created_at: string,
    execute: string,
    expired_at: string,
    id: string,
    is_npos: true,
    payee_currency: string,
    payer: string,
    payer_currency: string,
    payer_system: string,
    price: number,
    status: string,
    updated_at: string,
    locked_amount:number,
    traded_amount:number,
    payee:string
}

export type PaymentsHistory = {
    code?: number,
    data: PaymentHistoryData[],
    has_next: boolean,
    next_cursor: string,
    prev_cursor: string,
    success: boolean
}

export class PaymentService {
    
    public static getUserActivities = async (filters:PaymentList) : Promise<PaymentsHistory> => {
        let target = ``;
        await Api.baseUrlGenerator(`base`).then( envResponse => {
            target = `${envResponse}/getActivities?`;
        });
        for (const key in filters){
            if (key !== 'cursor') target += `${key}=${filters[key as keyof PaymentList]}`

            if (key === 'cursor') {
                let cursosStr = filters[key as keyof PaymentList] as string;
                if (cursosStr === '0' || cursosStr === undefined || cursosStr === '') {
                    cursosStr = JSON.stringify({})
                    target += `${key}=${btoa(cursosStr)}`
                } else {
                    target += `${key}=${cursosStr}`
                }
            }
            if (key !== 'sort') target += "&";
        }
        return Api.get(target)
    }
    
    public static getQuotations = (moeda: string, fee:number, unitFee: number): Promise<any> => {
        const spread = (fee/100)+1;
        const target = `${env.config.priceUrl}/quote/${moeda}?spread=${spread}&unit=${unitFee}`;
        return Api.get(target)
    }

    public static createPayment = async (payload: PaymentCreation): Promise<any> => {
        let target = ``;
        await Api.baseUrlGenerator(`base`).then( envResponse => {
            target = `${envResponse}/paymentCharge`;
        });
        return Api.put(target, payload)
    }

    public static getPaymentCharge = async (id: string): Promise<any> => {
        let target = ``;
        await Api.baseUrlGenerator(`base`).then( envResponse => {
            target = `${envResponse}/getPaymentCharge/${id}`;
        });
        return Api.get(target)
    }

    public static makeWithdrawalRequest = async (payload: WithdrawalPayload) : Promise<makeWithdrawalResponse> => {
        let target = ``;
        await Api.baseUrlGenerator(`base`).then( envResponse => {
            target = `${envResponse}/withdrawal`;
        });
        return Api.put(target, payload);
    }

    public static transferAccount = async (payload: WithdrawalPayload) : Promise<TransferAccount> => {
        let target = ``;
        await Api.baseUrlGenerator(`base`).then( envResponse => {
            target = `${envResponse}/accountTransfer`;
        });
        return Api.put(target, payload);
    }

    public static getPreview = async (pair: string) : Promise <any> => {
        let target = ``;
        await Api.baseUrlGenerator(`base`).then( envResponse => {
            target = `${envResponse}/withdrawalPreview/${pair}`;
        });
        return Api.get(target);
    }

    public static getReceipt = async (txId: string) : Promise <any> => {
        let target = ``;
        await Api.baseUrlGenerator(`base`).then( envResponse => {
            target = `${envResponse}/getPaymentCharge/${txId}`;
        });
        return Api.get(target);
    }

    public static getWIthdrawalReceipt = async (txId: string) : Promise <withdrawalReceipt> => {
        let target = ``;
        await Api.baseUrlGenerator(`base`).then( envResponse => {
            target = `${envResponse}/getWithdrawal/${txId}`;
        });
        return Api.get(target);
    }
}